import { render, staticRenderFns } from "./detail_hd.vue?vue&type=template&id=40c5b544&scoped=true"
import script from "./detail_hd.vue?vue&type=script&lang=js"
export * from "./detail_hd.vue?vue&type=script&lang=js"
import style0 from "./detail_hd.vue?vue&type=style&index=0&id=40c5b544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c5b544",
  null
  
)

export default component.exports